import { UploadType } from './../../base-models/upload-type';
import { ConfigService } from './../../base-services/config.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { AbstractCustomControl, MakeProvider } from "../abstract-custom-control";
import { HttpEventType } from '@angular/common/http';

@Component({
    selector: 'yt-upload',
    templateUrl: './upload.component.html',
    providers: [ MakeProvider(YtUpload) ]
})
export class YtUpload extends AbstractCustomControl<any>{
    constructor(protected changeDetectorRef: ChangeDetectorRef,
                protected baseDataService: BaseDataService,
                protected configService: ConfigService){
        super(changeDetectorRef);
    }

    @ViewChild('fileInput', { static: true }) fileInput: ElementRef;

    selectedFile: File;
    imageUrl: string = 'assets/images/no-image.png';
    uploadProgressLabel: string = '0%';
    uploading: boolean = false;
    uploaded: boolean = false;
    uploadProgress: number = 0;
    statusText: string = '';

    @Input() ModelName: string;
    @Input() PostName: string;
    @Input() UploadType: UploadType;
    @Input() SupportedImageType: string[] = [];

    onFileChanged(event){
        if(event && event.target.files && event.target.files.length > 0){
            if(this.SupportedImageType.length == 0 || this.SupportedImageType.indexOf(event.target.files[0].type) > -1){
                this.selectedFile = event.target.files[0];
                this.onUpload();
            }
            else{
                alert('Odabrani format nije odgovarajući. Podržani formati su: ' + this.SupportedImageType.join(', '));
            }
        }
    }

    onUpload(){
        if(this.selectedFile != null){
            var formData = new FormData();
            formData.append('file', this.selectedFile, this.selectedFile.name);
            this.uploading = true;
            this.baseDataService.Post(this.ModelName, this.PostName, formData, null, null, { reportProgress: true, observe: 'events' })
                .subscribe(event => {
                    if(event['type'] == HttpEventType.UploadProgress){
                        this.uploadProgressLabel = (event['loaded'] / event['total'] * 100).toString() + '%';
                        this.uploadProgress = Math.round(event['loaded'] / event['total'] * 100);
                    }
                    else if(event['type'] == HttpEventType.Response){
                        if(this.UploadType == UploadType.Image)
                            this.imageUrl = this.configService.GetApiUrl() + event['body'].toString();
                        this.uploading = false;
                        this.uploaded = true;
                        this.value = event['body'].toString();
                        this.statusText = "FW.ACTION.UPLOAD.SUCCESS";
                    }
                    else if(event['type'] == HttpEventType.ResponseHeader){
                        if(event['status'] == 500)
                            this.statusText = "Error";
                    }
                })
        }
    }

    writeValue(value: any){
        super.writeValue(value);
        if(this.UploadType == UploadType.Image){
            if(value != null && value != '')
                this.imageUrl = this.configService.GetApiUrl() + value;
            else
                this.imageUrl = "assets/images/no-image.png";
        }
        this.uploading = false;
        this.uploaded = false;
        this.selectedFile = null;
    }
    clearImage() {
        this.imageUrl = 'assets/images/no-image.png'; 
        this.selectedFile = null;
        this.uploaded = false;
        this.value = null;
    }
    
}